import { GetInvoicePaymentRecapApiParameter, getInvoicePaymentRecap } from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { InvoiceCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = CustomApiHandler<GetInvoicePaymentRecapApiParameter & HasOnSuccess & HasOnError, InvoiceCollectionModel>;

export const DispatchBeginLoadInvoicePaymentRecap: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadInvoicePaymentRecap",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getInvoicePaymentRecap(props.apiParameter);
};

export const CompleteLoadInvoicePaymentRecap: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteLoadInvoicePaymentRecap",
            InvoicePaymentRecapResult: props.apiResult
        });
    }
};

export const chain = [DispatchBeginLoadInvoicePaymentRecap, PopulateApiParameter, RequestDataFromApi, CompleteLoadInvoicePaymentRecap];

const adiLoadInvoicePaymentRecap = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        customerSequence: "-1",
        page: 1,
        pageSize: 1,
        showOpenOnly: true,
        properties: {},
        sort: "invoiceDate DESC",
        onSuccess: (result) => { }
    },
    "ADILoadInvoicePaymentRecap",
);
export default adiLoadInvoicePaymentRecap;
